window.addEventListener( 'load', () => {

	AOS.init();

	document.addEventListener( 'lazyloaded', () => {
		AOS.refresh();
	} );

	const tabSelectors = document.querySelectorAll( '[data-tab-item] a' );

	/**
	 * Because tabs sometimes have different heights,
	 * refresh AOS on tab switch event so that elements beneath
	 * can update appropriately.
	 */
	if ( tabSelectors.length ) {
		tabSelectors.forEach( tabSelector => {
			tabSelector.addEventListener( 'click', () => {
				AOS.refresh();
			} );
		} );
	}

} );

const isForcedPage = document.querySelector( '.page-template-template-1-0-understanding-pnh' );

if ( isForcedPage ) {

	window.addEventListener( 'beforeunload', () => {
		document.querySelector( 'html' ).style.scrollBehavior = '';
		window.scrollTo( 0,0 );
		s.refresh();
	} );

	window.addEventListener( 'pageshow', () => {
		document.querySelector( 'html' ).style.scrollBehavior = '';
		window.scrollTo( 0,0 );
		s.refresh();
	} );

}
